/*
 * @Author: yanghailong
 * @Date: 2023-08-23 09:07:24
 * @Last Modified by: yanghailong
 * @Last Modified time: 2025-03-25 17:46:26
 */
import Konva from "konva"
import { GraphElement } from "../graph-element.js"
import { createFromJSON } from "./help.js"


class ESSElement extends GraphElement {

  constructor(topology, x, y, attrs) {
    super(topology, 'ess', x, y, {
      text: '储能系统',
      port: true,
      // useTransparentImg: true,
      ...attrs,
    })

    this.sort = 0
    this.childrenDataList = []

    this.socTimer = null
    this.animRunning = false


    // eblock个数文字颜色
    this.ebNormalColor = 'rgb(44, 213, 99)'
    this.ebHoverColor = 'rgb(76, 175, 80)'


    this.onLoad(() => {
      this.prop_x = -10
      this.prop_y = 70
      // 属性
      this.addProperty('功率', 'kW')
      this.addProperty('电流', 'A')
      this.addProperty('SOC', '%', { fill: 'rgb(44, 213, 99)' })

      // eBlock数量
      this.addEblockNumber()

      // SOC状态
      this.addSOCMask()
    })

    this.onRemove(() => {
      console.log('remove ess')
      this._stopSOCAnimate()
    })
  }


  updateData(data) {
    this.updateProperty('功率', data.p_total)
    this.updateProperty('电流', data.i_a)
    this.updateProperty('SOC', data.soc)
    this.updateSOCMask(data.soc)
  }

  /**
   * 设置显示名称
   * @param text
   */
  setLabel(text) {
    this.label.setText(text)
  }

  /**
   * 设置名称位置
   * @param {number} x
   * @param {number} y
   */
  setLabelPos(x, y) {
    this.label.x(x)
    this.label.y(y)
  }

  setData(data) {
    this.childrenDataList = data.eBlocks || []
    this.updateEBNumber(this.childrenDataList.length)

    //
    this.sort = data.sort
    this.setLabel(this.sort + '#储能方阵')

  }

  addEblockNumber() {
    this.eBlockNumber = new Konva.Text({
      x: this.prop_x,
      y: this.prop_y,
      width: 120,
      text: 'eBlock: 0个 ▶',
      fill: this.ebNormalColor,
      align: 'left',
      verticalAlign: 'top',
      fontSize: 12,
    })
    this.g.add(this.eBlockNumber)
    // this.realDataCount++


    this.eBlockNumber.on('click', (event) => {
      // window.dispatchEvent(new CustomEvent('topo:openESS', {
      //   bubbles: true,
      //   detail: {
      //     ...this.toJSON(),
      //   }
      // }))

      this.__topology.dispatchEvent({
        type: 'topo:openESS',
        detail: {
          ...this.toJSON(),
        }

      })

    })

    this.eBlockNumber.on('mouseover', () => {
      this.eBlockNumber.setAttr('fill', this.ebHoverColor)
      this.__topology.dom.graphElem.style.cursor = 'pointer'
    })

    this.eBlockNumber.on('mouseout', () => {
      this.eBlockNumber.setAttr('fill', this.ebNormalColor)
      this.__topology.dom.graphElem.style.cursor = 'default'
    })

  }

  addSOCMask() {
    this.socMask = new Konva.Group()
    for (let i = 4; i >= 0; i--) {
      const bar = new Konva.Rect({
        x: 4,
        y: 8 + i * 6,
        width: 13,
        height: 2,
        fill: '#55F48B',
        strokeWidth: 0,
        cornerRadius: 3,
        visible: false,
      })
      this.socMask.add(bar)
    }

    this.g.add(this.socMask)
  }

  /**
   * 更新电池显示状态
   * @param {number} socValue - SOC 值，范围 0-100
   */
  updateSOCMask(socValue) {
    // 确保 socValue 在 0-100 范围内
    const soc = Math.max(0, Math.min(100, socValue || 0))
    
    // 计算应该显示几个 bar（共 5 个 bar，每个代表 20%）
    const visibleBars = Math.ceil((soc / 100) * 5)
    
    // 更新每个 bar 的显示状态
    this.socMask.children.forEach((bar, index) => {
      // bar 从下到上排列（index 0 是最下面的），所以需要反向判断
      if (index < visibleBars) {
        bar.visible(true)
      } else {
        bar.visible(false)
      }
    })
  }

  updateEBNumber(num) {
    this.eBlockNumber.setAttr('text', `eBlock: ${num} 个 ▶`)
  }

  _runSOCAnimate() {
    this.animRunning = true
    let soc = 0
    this.socTimer = setInterval(() => {
      this.updateSOCMask(soc)
      // console.log('soc', soc);

      this.updateProperty('SOC', (soc * 100).toFixed(2))
      soc += 0.1
      if (soc >= 1) {
        soc = 0
      }
    }, 2000);
  }

  _stopSOCAnimate() {
    this.animRunning = false
    clearInterval(this.socTimer)
  }

  addToLayer(layer) {
    super.addToLayer(layer)
    // if (!this.animRunning) {
    //   this._runSOCAnimate()
    // }
  }


  toJSON() {
    return {
      ...super.toJSON(),
      childrenDataList: this.childrenDataList
    }
  }

  static _createFunc = createFromJSON(this)
  static async fromJSON(topology, node, complete) {
    const elem = await this._createFunc(topology, node, complete)
    elem.childrenDataList = node.childrenDataList
    elem.setLabel(node.label)
    elem.updateEBNumber(node.childrenDataList.length)
    return elem
  }
}


export { ESSElement }
